exports = module.exports = require("../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3jqxmuzgJACcIuv8X_Rg8a{width:100%;min-width:0;height:40px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center}html[dir] ._3jqxmuzgJACcIuv8X_Rg8a{background-color:var(--white);border-bottom:1px solid var(--neutralLighter);padding:0 16px}.iPuYhbGqn-GRgJtmc1Xrt{height:100%}", ""]);
// Exports
exports.locals = {
	"chatContact": "_3jqxmuzgJACcIuv8X_Rg8a",
	"persona": "iPuYhbGqn-GRgJtmc1Xrt"
};